import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-onccmeasure',
  templateUrl: './onccmeasure.component.html',
  styleUrls: ['./onccmeasure.component.css']
})

export class ONCCMeasureComponent implements OnInit {

  public index2active: any;
  constructor() { }



  ngOnInit(): void {
    this.index2active = localStorage.getItem('cqmstab2') || 0;
    localStorage.removeItem("cqmstab2");
  }



}
